angular.module("AccountingBoxApp").filter("invoiceFilter", function($filter) {
  function roundTwoDecimals(number) {
    return Math.round(number * 100) / 100;
  }

  var filteredDataMemoized = _.memoize(filteredData, function resolver() {
    return JSON.stringify(arguments);
  });

  function filteredData(invoices, query) {
    // console.log("filter invoices", invoices.length);
    invoices = invoices.map(function(i) {
      i.invoiceDateFormattedShort = moment(i.invoiceDate).format("L");
      i.invoiceDateFormattedLong = moment(i.invoiceDate).format("LL");
      i.totalAmountFormattted = $filter("currency")(i.totalAmount, "NONE", 2);
      i.totalAmountFormatttedOriginal = roundTwoDecimals(i.totalAmount).toFixed(
        2
      );
      i.amountDueFormattted = $filter("currency")(i.amountDue, "NONE", 2);
      i.amountDueFormatttedOriginal = roundTwoDecimals(i.amountDue).toFixed(2);
      return i;
    });
    var options = {
      shouldSort: true,
      threshold: 0.08,
      location: 0,
      distance: 10000,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        "customer.name",
        "vendor.name",
        "invoiceNumber",
        "Lines.account.description",
        "Lines.account.accountNumber",
        "Lines.account.subCategory.description",
        "statusText",
        "invoiceDateFormattedShort",
        "invoiceDateFormattedLong",
        "totalAmountFormattted",
        "totalAmountFormatttedOriginal",
        "amountDueFormattted",
        "amountDueFormatttedOriginal"
      ]
    };
    if (query && query.length > 0) {
      var fuse = new Fuse(invoices, options); // "list" is the item array
      invoices = fuse.search(query);
      invoices = invoices.map((t) => t.item);
    }
    return invoices;
  }

  return function(invoices, query) {
    return filteredDataMemoized(invoices, query);
  };
});
